module.exports = __webpack_public_path__ + "img/IMG_8618_L.388049a5.webp";